import { useDisclosure } from '@amzn/ring-ui-react-components';
import { NpssNavBarDesktop } from 'src/components/Navbar/NpssNavBarDesktop';
import { NpssNavBarMobile } from 'src/components/Navbar/NpssNavBarMobile';
import { SettingsModal } from 'src/shared/components/SettingsModal';
import { useIsMobile } from 'src/shared/hooks';

export const NpssNavBar = () => {
  const isMobile = useIsMobile();

  const { isOpen, onClose } = useDisclosure();

  return (
    <>
      {isMobile ? <NpssNavBarMobile /> : <NpssNavBarDesktop />}
      <SettingsModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};
